var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"title":"Drag the map to choose a location","close-on-click-modal":false,"close-on-press-escape":false},on:{"close":_vm.onClose}},[_c('map-view',{on:{"confirm":_vm.onConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }